export const useHandleErrorResponse = ({response}) => {
  switch (response.status) {
    case 401:
      window.location.href = '/';
      break;
    case 403:
      window.location.href = '/';
      break;
    default:
      return response.response;
  }
};
